/* Click Fencing - plan references, named plans, customer accounts, and the CRM contact card.
 *
 * Pete 2026-09-01: "make sure this creates their customer contact card in the crm and we
 * can see all their quotes and plans. let them be able to save their plans under a name
 * they want. make sure we can search the crm for their contact and see all their
 * information."
 *
 * Pete 2026-09-02: "we really need the pdf drawing of the plan and the full parts list to go
 * along with every drawing made on the calculator. each output from the calculator should
 * have a reference number we can search on the crm to find the drawing and order form they
 * made, even if it didnt go to cart."
 *
 * FIVE JOBS, deliberately independent so one failing cannot take the others down.
 *
 * 1. NAME A PLAN. A rename control on the Your Quotes panel, written straight onto the
 *    saved quote.
 *
 * 2. THE CRM CONTACT CARD. Calculator enquiries used to go ONLY to the Cloudflare D1 store
 *    behind clickfencing-crm-api, which has no UI and is not the CRM Pete opens. Rather than
 *    rewrite whichever script sends that enquiry, this MIRRORS it: window.fetch and
 *    navigator.sendBeacon are wrapped, a POST to .../enquiry is spotted, and the same payload
 *    is forwarded to the CRM's click-quote-intake. The original request is untouched and its
 *    result returned unchanged - the mirror can only ever add.
 *
 * 3. PLANS FOLLOW THE ACCOUNT, through the Shopify app proxy at /apps/cf-account/quotes.
 *
 * 4. A REFERENCE ON EVERY PLAN, AND EVERY PLAN IN THE CRM - see the block below.
 *
 * 5. THE PLAN PDF - drawing plus the full parts list - built on quote-review and filed
 *    against the contact, so the office can open exactly what the customer designed.
 *
 * NOTHING HERE MAY COST A LEAD OR BREAK A QUOTE. Every entry point is wrapped in try/catch,
 * every network call is fire-and-forget, and no failure changes what the customer sees.
 */
(function () {
  'use strict';

  var CRM_INTAKE = 'https://mhzmtafzxeshqqtktbwh.supabase.co/functions/v1/click-quote-intake';
  var ACCOUNT_API = '/apps/cf-account/quotes';
  var ENQUIRY_RE = /clickfencing-crm-api[^/]*\/enquiry\b/i;

  var QUOTES_KEY = {
    '/pages/flat-top-fence-calculator': 'flattop_quotes',
    '/pages/blade-fence-calculator': 'blade_quotes',
    '/pages/perfmesh-fence': 'perfmesh_quotes',
    '/pages/glass-fencing': 'ullc_quotes'
  };
  var ALL_KEYS = ['flattop_quotes', 'blade_quotes', 'perfmesh_quotes', 'ullc_quotes'];

  var TRIES = 0, MAX_TRIES = 200;

  function cust() { return window.cfCustomer || null; }
  function loggedIn() { var c = cust(); return !!(c && c.loggedIn && c.id); }

  function readQuotes(key) {
    try { return JSON.parse(localStorage.getItem(key) || '[]') || []; } catch (e) { return []; }
  }
  function writeQuotes(key, arr) {
    try { localStorage.setItem(key, JSON.stringify(arr)); return true; } catch (e) { return false; }
  }

  /* quoteNum restarts at 1 per calculator, so it is not unique on its own. Still used as the
     key for the customer-account sync, which is scoped to one signed-in person. It is NOT
     what the CRM keys on any more - see planRef below. */
  function refFor(q) {
    return String(q.calcType || 'Calc') + '-' + String(q.quoteNum != null ? q.quoteNum : (q.generatedAt || ''));
  }

  function planPayload(q) {
    return {
      planName: q.quoteName || null,
      quoteReference: q.planRef || refFor(q),
      calculator: q.calcType || null,
      pricingType: q.pricingType || null,
      grandTotal: q.grandTotal != null ? q.grandTotal : null,
      currency: q.currency || 'AUD',
      sections: q.sections || null,
      savedAt: q.generatedAt || null,
      lines: q.breakdown || []
    };
  }

  function allLocalPlans() {
    var out = [];
    for (var i = 0; i < ALL_KEYS.length; i++) {
      var arr = readQuotes(ALL_KEYS[i]);
      for (var j = 0; j < arr.length; j++) out.push(planPayload(arr[j]));
    }
    return out;
  }

  /* ---------- 4. a reference on every plan ----------
     CF-GL-7K3M9Q, minted in the browser the moment a plan is saved. Not on enquiry, not on
     the server: a plan that is never sent anywhere still has to have one, and it has to be
     the same code the customer sees on screen, in their PDF and in their email.

     There WAS already a reference - quote-review.js mints CF-FRAM-14-<uuid8> - but only when
     somebody opens the Enquire modal, so an abandoned plan had none, and the mirror fell back
     to calcType + quoteNum ("FlatTop-14"), which restarts per calculator and therefore repeats
     between customers. Useless as something to search on.

     ALPHABET has no I, L, O, U, 0 or 1. This gets read down the phone. */

  var VISITOR_KEY = 'cf_visitor_id';
  var PUSHED_KEY = 'cf_pushed_plans';
  var REF_ALPHABET = '23456789ABCDEFGHJKMNPQRSTVWXYZ';

  function visitorId() {
    try {
      var v = localStorage.getItem(VISITOR_KEY);
      if (v) return v;
      v = 'v' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
      try { if (window.crypto && crypto.randomUUID) v = crypto.randomUUID(); } catch (e) {}
      localStorage.setItem(VISITOR_KEY, v);
      return v;
    } catch (e) { return ''; }
  }

  function calcCode(calcType) {
    var t = String(calcType || '').toLowerCase();
    if (t.indexOf('flat') >= 0) return 'FT';
    if (t.indexOf('blade') >= 0) return 'BL';
    if (t.indexOf('perf') >= 0 || t.indexOf('mesh') >= 0) return 'PM';
    return 'GL';
  }

  function mintRef(calcType) {
    var body = '';
    try {
      if (window.crypto && crypto.getRandomValues) {
        var buf = new Uint8Array(6);
        crypto.getRandomValues(buf);
        for (var i = 0; i < 6; i++) body += REF_ALPHABET[buf[i] % REF_ALPHABET.length];
      }
    } catch (e) {}
    while (body.length < 6) body += REF_ALPHABET[Math.floor(Math.random() * REF_ALPHABET.length)];
    return 'CF-' + calcCode(calcType) + '-' + body;
  }

  /* The glass calculator saves a raked section without its retainedHeight - the panel
     height the customer chose (1300-2100, matching the James Glen variant). Everything
     that re-renders a SAVED plan therefore falls back to a hard-coded "200": the review
     page caption, the drawing in the PDF, and the CRM. The parts list is unaffected,
     because it is built from live state at the time - which is why the right panel is
     still ordered. Copy the live value onto the saved plan so the picture agrees with
     the parts list. Only possible while the calculator instance is on the page, which is
     exactly when this runs. */
  function stampRakeHeights(q) {
    try {
      var gc = window.glassCalculator || window.glassFencingCalculator;
      if (!gc || !gc.state || !gc.state.sections) return false;
      if (!q || !Array.isArray(q.sections)) return false;
      var changed = false;
      for (var i = 0; i < q.sections.length; i++) {
        var sec = q.sections[i];
        if (!sec || !sec.hasRaked || sec.retainedHeight) continue;
        var live = gc.state.sections[String(sec.num)];
        if (live && live.retainedHeight) {
          sec.retainedHeight = String(live.retainedHeight);
          changed = true;
        }
      }
      return changed;
    } catch (e) { return false; }
  }

  /* Gives every saved plan a reference and writes it back, so the code on the customer's
     screen today is the code we hold forever. */
  function ensureRefs() {
    for (var i = 0; i < ALL_KEYS.length; i++) {
      var key = ALL_KEYS[i];
      var arr = readQuotes(key);
      var dirty = false;
      for (var j = 0; j < arr.length; j++) {
        if (arr[j] && !arr[j].planRef) {
          arr[j].planRef = mintRef(arr[j].calcType || key);
          dirty = true;
        }
        if (stampRakeHeights(arr[j])) dirty = true;
      }
      if (dirty) writeQuotes(key, arr);
    }
  }

  /* The saved copy of the quote an enquiry is about, so an enquiry can carry the SAME
     reference the customer already has rather than minting a second one. */
  function refForEnquiry(q) {
    if (q && q.planRef) return q.planRef;
    var name = String((q && q.quoteName) || '').trim();
    var i, j, arr, s;
    for (i = 0; i < ALL_KEYS.length; i++) {
      arr = readQuotes(ALL_KEYS[i]);
      for (j = 0; j < arr.length; j++) {
        s = arr[j];
        if (!s || !s.planRef) continue;
        var sameNum = q && q.quoteNum != null && String(s.quoteNum) === String(q.quoteNum) &&
                      String(s.calcType || '') === String(q.calcType || '');
        if (sameNum || (name && String(s.quoteName || '').trim() === name)) return s.planRef;
      }
    }

    /* 2026-09-07 (Pete: "fix the duplicate plan - calculator reference wins").
       Match on the DESIGN when the number and the name both fail. Without this the
       caller falls through to the reference the enquiry minted and the same fence is
       filed twice under two references.

       Measured on Luke's card: CF-FT-9QF6N2 at 02:33 and CF-FLAT-45-afef360f at 02:39,
       same plan name, same $4,656.84, same 4 sections, 24 identical parts each. The
       first carried the drawing and a 3.3MB PDF; the second only a 48KB one, so the
       duplicate was also the poorer record.

       Calculator, total and section count together are specific enough: a customer
       would have to save two plans on the same calculator, to the cent, with the same
       number of sections, for this to collide - and those two plans are the same
       fence anyway. Deliberately NOT matched on total alone. */
    var calc = String((q && q.calcType) || '');
    var total = q && q.grandTotal != null ? Number(q.grandTotal) : null;
    var secs = q && Array.isArray(q.sections) ? q.sections.length : null;
    if (calc && total != null && isFinite(total)) {
      for (i = 0; i < ALL_KEYS.length; i++) {
        arr = readQuotes(ALL_KEYS[i]);
        for (j = 0; j < arr.length; j++) {
          s = arr[j];
          if (!s || !s.planRef) continue;
          if (String(s.calcType || '') !== calc) continue;
          var sTotal = s.grandTotal != null ? Number(s.grandTotal) : null;
          if (sTotal == null || !isFinite(sTotal)) continue;
          if (Math.abs(sTotal - total) > 0.005) continue;
          var sSecs = Array.isArray(s.sections) ? s.sections.length : null;
          if (secs != null && sSecs != null && sSecs !== secs) continue;
          return s.planRef;
        }
      }
    }
    return null;
  }

  /* ---------- 2. the CRM contact card ---------- */

  var crmSent = {};

  /* customer may be null: an anonymous saved plan is pushed against the browser id alone and
     the intake makes one placeholder card per browser, folding it into the real customer the
     moment they identify themselves. */
  function postPlans(customer, plans, page) {
    try {
      if (!plans || !plans.length) return;
      var vid = visitorId();
      var named = !!(customer && customer.name && (customer.email || customer.phone));
      if (!named && !vid) return;

      /* One post per (who + which plans + whether files are attached). A double-tapped Send,
         or a beacon firing alongside a fetch, must not create the contact twice - but an
         enriching push carrying a drawing or a PDF must still get through. */
      var stamp = (named ? (customer.email || customer.phone) : 'anon:' + vid) + '|' +
        plans.map(function (p) {
          return p.quoteReference + (p.pdfBase64 ? '+pdf' : '') + (p.drawingPngBase64 ? '+img' : '');
        }).join(',');
      if (crmSent[stamp]) return;
      crmSent[stamp] = true;

      var payload = { plans: plans, page: page || document.title, visitorId: vid };
      if (named) payload.customer = customer;
      var body = JSON.stringify(payload);

      /* sendBeacon and fetch(keepalive) both refuse a body over roughly 64KB, and a beacon
         over the limit returns false having sent NOTHING - the lead would vanish silently,
         which is the one outcome this file exists to prevent. A drawing, and certainly a PDF,
         pushes the body past that, so anything large goes as an ordinary fetch. */
      var big = body.length > 60000;

      // text/plain keeps this a CORS simple request - no preflight to fail.
      if (!big && navigator.sendBeacon) {
        try {
          navigator.sendBeacon(CRM_INTAKE, new Blob([body], { type: 'text/plain' }));
          return;
        } catch (e) {}
      }
      fetch(CRM_INTAKE, { method: 'POST', body: body, keepalive: !big, mode: 'cors' })
        .catch(function () {});
    } catch (e) {}
  }

  /* ---------- 2b. the plan drawing ----------
     WHY XMLSerializer AND NOT innerHTML. PerfMesh, Blade and Flat Top draw their fence as a
     nested <svg> built with createElementNS. Read back through innerHTML that SVG loses its
     namespace, so once it is inside a <foreignObject> the browser parses it as unknown XHTML
     and draws nothing - the posts, panels and gate all disappear and only the stray dimension
     digits survive, run together. It looks like a rendering glitch and it silently ships a
     useless picture. XMLSerializer keeps the namespace and the fence draws. Verified against a
     real PerfMesh quote and a real Frameless Glass quote, which take different code paths
     (nested SVG vs plain styled divs).

     CAPTURED EAGERLY because the enquiry bridge navigates away the instant its button is
     clicked and rasterising is asynchronous. */

  var DRAWING_KEY = 'cf_plan_drawing';
  var DRAWING_BUDGET = 45000;
  var DRAWING_LADDER = [[1.5, 'image/png', undefined],
                        [1, 'image/png', undefined],
                        [1.5, 'image/jpeg', 0.85]];

  function readDrawing() {
    try {
      var raw = sessionStorage.getItem(DRAWING_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  function rasterise(el, scale, type, quality, cb) {
    try {
      var rect = el.getBoundingClientRect();
      var w = Math.min(1400, Math.ceil(rect.width));
      var h = Math.ceil(rect.height);
      if (!w || !h) return cb(null);

      var body = new XMLSerializer().serializeToString(el.cloneNode(true));
      var html = '<div xmlns="http://www.w3.org/1999/xhtml" style="width:' + w +
        'px;background:#ffffff;font-family:Helvetica,Arial,sans-serif;color:#0f172a">' +
        body + '</div>';
      var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="' + Math.round(w * scale) +
        '" height="' + Math.round(h * scale) + '"><foreignObject width="100%" height="100%"' +
        ' transform="scale(' + scale + ')">' + html + '</foreignObject></svg>';

      var img = new Image();
      img.onload = function () {
        try {
          var c = document.createElement('canvas');
          c.width = Math.round(w * scale);
          c.height = Math.round(h * scale);
          var x = c.getContext('2d');
          x.fillStyle = '#ffffff';
          x.fillRect(0, 0, c.width, c.height);   // JPEG has no alpha; without this it goes black
          x.drawImage(img, 0, 0);
          cb({ data: c.toDataURL(type, quality), w: c.width, h: c.height });
        } catch (e) { cb(null); }
      };
      img.onerror = function () { cb(null); };
      img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
    } catch (e) { cb(null); }
  }

  function captureDiagram(done) {
    var el = document.getElementById('qr-section-diagrams');
    if (!el || !el.getBoundingClientRect().height) return done(null);
    var i = 0, best = null;
    (function next() {
      if (i >= DRAWING_LADDER.length) return done(best);
      var step = DRAWING_LADDER[i++];
      rasterise(el, step[0], step[1], step[2], function (d) {
        if (d && (!best || d.data.length < best.data.length)) best = d;
        if (d && d.data.length <= DRAWING_BUDGET) return done(d);
        next();
      });
    })();
  }

  var lastDrawingSig = '';

  function refreshDrawing(after) {
    try {
      var el = document.getElementById('qr-section-diagrams');
      if (!el) return;
      var nameEl = document.getElementById('qr-quote-name');
      var name = nameEl ? (nameEl.textContent || '').trim() : '';
      var sig = name + '|' + el.innerHTML.length;
      if (sig === lastDrawingSig) { if (after) after(readDrawing()); return; }
      lastDrawingSig = sig;
      captureDiagram(function (shot) {
        if (!shot) { if (after) after(null); return; }
        var rec = { name: name, png: shot.data, w: shot.w, h: shot.h };
        try { sessionStorage.setItem(DRAWING_KEY, JSON.stringify(rec)); } catch (e) {}
        if (after) after(rec);
      });
    } catch (e) {}
  }

  /* ---------- 5. the plan PDF ----------
     Pete asked for "the pdf drawing of the plan and the full parts list" on every plan.

     jsPDF is already loaded on quote-review (the page's own enquiry flow uses it), so this
     renders from the SAME saved quote object the customer is looking at: the drawing we just
     captured, then every line of the breakdown. It computes nothing - every figure is read
     off the stored quote - so there is no second source of truth for a price. */

  function pdfMoney(n, cur) {
    var v = Number(n);
    if (!isFinite(v)) return '';
    return '$' + v.toFixed(2) + (cur && cur !== 'AUD' ? ' ' + cur : '');
  }

  /* What the customer is actually buying, in words. Everything here is derived from the
     plan's own parts list and sections, so it works for all four calculators, needs no
     calculator instance (the aluminium ones are closed over), and reads correctly for
     plans saved before this existed.

     EnduroShield has no line of its own - it is priced into the glass, and
     cf-enduro-label.js renames the panel lines to "..., EnduroShield Coated". That name
     is the only signal there is, and it is a reliable one. */
  var SPEC_FINISHES = [
    'Stainless Mirror Finish', 'Satin Mirror Finish', 'Mirror Finish',
    'Satin Black', 'Matt Black', 'Satin White', 'Monument', 'Stainless'
  ];

  function specLineNames(q) {
    var lines = Array.isArray(q.breakdown) ? q.breakdown : [];
    var out = [];
    for (var i = 0; i < lines.length; i++) {
      var l = lines[i] || {};
      var n = String(l.item || l.description || l.title || '').trim();
      if (n) out.push(n);
    }
    return out;
  }

  function specFirstFinish(list) {
    for (var i = 0; i < SPEC_FINISHES.length; i++) {
      for (var j = 0; j < list.length; j++) {
        if (list[j].toLowerCase().indexOf(SPEC_FINISHES[i].toLowerCase()) >= 0) return SPEC_FINISHES[i];
      }
    }
    return null;
  }

  /* The finish and the mount are their own rows; repeating them on every hinge makes
     the block unreadable. */
  function specTidyHinge(n) {
    var t = n;
    for (var i = 0; i < SPEC_FINISHES.length; i++) {
      t = t.replace(new RegExp(SPEC_FINISHES[i], 'ig'), '');
    }
    t = t.replace(/\b(glass to glass|wall to glass|glass to wall)\b/ig, '');
    t = t.replace(/\(pair\)/ig, '').replace(/\s{2,}/g, ' ').trim();
    return t.replace(/[\s,\u2013\u2014-]+$/, '');
  }

  function specRows(q) {
    var all = specLineNames(q);
    var joined = all.join(' | ');
    var hardware = [], hingeLines = [];
    for (var i = 0; i < all.length; i++) {
      if (/spigot|clamp|hinge|latch|bracket|post|kit/i.test(all[i])) hardware.push(all[i]);
      if (/hinge/i.test(all[i]) && !/hinge panel/i.test(all[i])) hingeLines.push(all[i]);
    }

    var hinges = [];
    for (var k = 0; k < hingeLines.length; k++) {
      var t = specTidyHinge(hingeLines[k]);
      if (t && hinges.indexOf(t) < 0) hinges.push(t);
    }

    var sections = Array.isArray(q.sections) ? q.sections : [];
    var softClose = /soft.?close/i.test(joined);
    var rakeHeights = [];
    for (var m = 0; m < sections.length; m++) {
      var sec = sections[m] || {};
      if (/soft.?close/i.test(String(sec.hingeType || ''))) softClose = true;
      if (sec.hasRaked && sec.retainedHeight && rakeHeights.indexOf(String(sec.retainedHeight)) < 0) {
        rakeHeights.push(String(sec.retainedHeight));
      }
    }

    // EnduroShield is a GLASS coating. On a mesh or aluminium plan the question does not
    // arise, and printing "Not included" there reads as a missing extra.
    var isGlass = /glass|frameless/i.test(String(q.calcType || '')) ||
                  /glass panel|rake panel/i.test(joined);

    var rows = [];
    var finish = specFirstFinish(hardware) || specFirstFinish(all);
    if (finish) rows.push(['Fence colour', finish]);
    if (hinges.length) {
      rows.push(['Hinges', hinges.join(' + ')]);
      rows.push(['Soft close hinges', softClose ? 'Yes' : 'No']);
    }
    if (rakeHeights.length) {
      rows.push([rakeHeights.length > 1 ? 'Rake panels' : 'Rake panel',
                 rakeHeights.join(', ') + 'mm high']);
    }
    if (isGlass) rows.push(['EnduroShield coating', /enduroshield/i.test(joined) ? 'Yes - included' : 'Not included']);
    return rows;
  }

  function buildPlanPdf(q, drawing, done) {
    try {
      if (!window.jspdf || !window.jspdf.jsPDF) return done(null);
      var doc = new window.jspdf.jsPDF({ unit: 'mm', format: 'a4' });
      var W = doc.internal.pageSize.getWidth();
      var H = doc.internal.pageSize.getHeight();
      var M = 14, y = M, cur = q.currency || 'AUD';
      /* A DIY plan is a supply-only parts order: the price is exact for the parts
         listed, so it must not be worded as an estimate subject to a site visit. */
      var diy = q.pricingType !== 'install';

      function room(need) {
        if (y + need > H - M) { doc.addPage(); y = M; return true; }
        return false;
      }

      doc.setFontSize(17);
      doc.text('Click Fencing - fence plan', M, y); y += 8;

      doc.setFontSize(12);
      doc.text(String(q.quoteName || 'Fence plan'), M, y); y += 6;

      doc.setFontSize(10);
      doc.text('Reference: ' + (q.planRef || ''), M, y); y += 5;
      doc.text('Range: ' + (q.calcType || '') + '    Pricing: ' +
        (q.pricingType === 'install' ? 'Supply & Install' : 'DIY / Supply only'), M, y); y += 5;
      if (q.grandTotal != null) {
        doc.text((diy ? 'Total: ' : 'Estimated total: ') +
          pdfMoney(q.grandTotal, cur) + ' (inc GST)', M, y); y += 5;
      }

      var spec = specRows(q);
      if (spec.length) {
        y += 2;
        doc.setFontSize(11);
        doc.text('Specification', M, y); y += 5;
        doc.setFontSize(9);
        for (var si = 0; si < spec.length; si++) {
          room(6);
          doc.text(spec[si][0], M, y);
          doc.text(String(spec[si][1]), M + 42, y);
          y += 4.6;
        }
        doc.setFontSize(10);
      }
      y += 3;

      if (drawing && drawing.png && drawing.w && drawing.h) {
        var maxW = W - M * 2;
        var w = maxW, h = drawing.h * (maxW / drawing.w);
        var maxH = 90;
        if (h > maxH) { h = maxH; w = drawing.w * (maxH / drawing.h); }
        room(h + 4);
        try {
          doc.addImage(drawing.png, /jpeg/i.test(drawing.png.slice(0, 20)) ? 'JPEG' : 'PNG',
                       M, y, w, h);
          y += h + 6;
        } catch (e) { /* an unreadable image must not lose the parts list */ }
      }

      var lines = Array.isArray(q.breakdown) ? q.breakdown : [];
      room(12);
      doc.setFontSize(12);
      doc.text('Parts list', M, y); y += 6;
      doc.setFontSize(9);

      if (!lines.length) {
        doc.text('No priced parts on this plan.', M, y); y += 5;
      } else {
        var colQty = W - M - 34, colTot = W - M;
        doc.text('Item', M, y);
        doc.text('Qty', colQty, y, { align: 'right' });
        doc.text('Total', colTot, y, { align: 'right' });
        y += 4;
        doc.setLineWidth(0.2);
        doc.line(M, y, W - M, y); y += 4;

        for (var i = 0; i < lines.length; i++) {
          var it = lines[i] || {};
          var label = String(it.item || it.description || 'Item') +
            (it.sku ? '  [' + it.sku + ']' : '');
          var wrapped = doc.splitTextToSize(label, W - M * 2 - 46);
          room(wrapped.length * 4.4 + 2);
          var qty = it.quantity;
          qty = (typeof qty === 'number' && qty % 1 !== 0) ? qty.toFixed(2) : String(qty == null ? '' : qty);
          doc.text(wrapped, M, y);
          doc.text(qty, colQty, y, { align: 'right' });
          doc.text(pdfMoney(it.totalPrice, cur), colTot, y, { align: 'right' });
          y += wrapped.length * 4.4 + 1.6;
        }

        room(10);
        doc.line(M, y, W - M, y); y += 5;
        doc.setFontSize(11);
        doc.text(diy ? 'Total' : 'Estimated total', M, y);
        doc.text(pdfMoney(q.grandTotal, cur), colTot, y, { align: 'right' });
        y += 7;
      }

      room(14);
      doc.setFontSize(8);
      doc.text(doc.splitTextToSize(diy
        ? 'Supply only (DIY). The price above is exact for the parts listed - it is not an estimate. ' +
          'It assumes the measurements you entered are correct, so please check them before ordering. ' +
          'Prices include GST. Installation is not included.'
        : 'This is an estimate produced by the Click Fencing online calculator. Final pricing may vary ' +
          'subject to site inspection, access conditions and material availability. Prices include GST.',
        W - M * 2), M, y);

      done(doc.output('datauristring'));
    } catch (e) { done(null); }
  }

  /* ---------- pushing plans to the CRM ---------- */

  function planHasParts(q) {
    var bd = q && q.breakdown;
    return !!(Array.isArray(bd) && bd.length) || Number(q && q.grandTotal) > 0;
  }

  // Cheap fingerprint - enough to notice a plan actually changed, not a checksum.
  function planStamp(q) {
    var bd = Array.isArray(q.breakdown) ? q.breakdown.length : 0;
    var sec = Array.isArray(q.sections) ? q.sections.length : 0;
    return [q.grandTotal, bd, sec, q.pricingType, q.quoteName].join('|');
  }

  function readPushed() {
    try { return JSON.parse(localStorage.getItem(PUSHED_KEY) || '{}') || {}; } catch (e) { return {}; }
  }
  function markPushed(map) {
    try { localStorage.setItem(PUSHED_KEY, JSON.stringify(map)); } catch (e) {}
  }

  /* Never send the whole library at once. A browser that has been building plans for a
     while - Pete's own has hundreds - would otherwise put every one of them in a single
     body, which no beacon will carry and which lands as one enormous request. Five per
     push, and the next tick takes the next five. A plan carrying a drawing or a PDF goes
     to the front so an enriching push is never the one that gets held back. */
  var PUSH_BATCH = 5;

  /* Every saved plan that has priced parts and has not been pushed in its current state.
     Somebody who merely loads the calculator has not made an output and must not become a
     contact card - hence planHasParts. */
  function pushSavedPlans(extraByRef) {
    try {
      ensureRefs();
      var pushed = readPushed();
      var withFiles = [], plain = [], stamps = {};
      for (var i = 0; i < ALL_KEYS.length; i++) {
        var arr = readQuotes(ALL_KEYS[i]);
        for (var j = 0; j < arr.length; j++) {
          var q = arr[j];
          if (!q || !q.planRef || !planHasParts(q)) continue;
          var stamp = planStamp(q);
          var extra = (extraByRef && extraByRef[q.planRef]) || null;
          if (pushed[q.planRef] === stamp && !extra) continue;
          var p = planPayload(q);
          if (extra) {
            if (extra.drawingPngBase64) p.drawingPngBase64 = extra.drawingPngBase64;
            if (extra.pdfBase64) p.pdfBase64 = extra.pdfBase64;
            withFiles.push(p);
          } else {
            plain.push(p);
          }
          stamps[q.planRef] = stamp;
        }
      }
      var out = withFiles.concat(plain).slice(0, PUSH_BATCH);
      if (!out.length) return;
      // Only mark what actually went, so the remainder is picked up on the next tick.
      out.forEach(function (p) {
        if (stamps[p.quoteReference]) pushed[p.quoteReference] = stamps[p.quoteReference];
      });

      var c = loggedIn() ? cust() : null;
      var customer = c ? {
        name: c.name || '', email: c.email || '', phone: c.phone || '',
        address: c.address || '', suburb: c.suburb || '', postcode: c.postcode || '',
        shopifyCustomerId: String(c.id)
      } : null;

      postPlans(customer, out,
        customer ? 'Click Fencing saved plans (signed in)' : 'Click Fencing calculator (saved plan)');
      markPushed(pushed);
    } catch (e) {}
  }

  /* WHICH SAVED PLAN IS ON SCREEN. Not by name alone: quote names are auto-generated and
     repeat constantly ("Frameless Glass Quote 1" appears nine times in one test browser), so
     a name match would happily file this plan's drawing and PDF against a different plan's
     reference. The active pill carries calcType and quoteNum, which together are exact.
     A plan matching BOTH wins; the pill alone beats the name alone. */
  function viewedQuote() {
    try {
      var nameEl = document.getElementById('qr-quote-name');
      var name = nameEl ? (nameEl.textContent || '').trim() : '';
      var pill = document.querySelector('.qr-quote-pill.is-active') ||
                 document.querySelector('.qr-quote-pill');
      var pnum = pill && pill.dataset ? pill.dataset.quoteNum : null;
      var pcalc = pill && pill.dataset ? pill.dataset.calcType : null;

      var both = null, byNum = null, byName = null;
      for (var i = 0; i < ALL_KEYS.length; i++) {
        var arr = readQuotes(ALL_KEYS[i]);
        for (var j = 0; j < arr.length; j++) {
          var q = arr[j];
          if (!q) continue;
          var numHit = pnum != null && String(q.quoteNum) === String(pnum) &&
                       (!pcalc || String(q.calcType || '') === String(pcalc));
          var nameHit = !!name && String(q.quoteName || '').trim() === name;
          if (numHit && nameHit && !both) both = q;
          if (numHit && !byNum) byNum = q;
          if (nameHit && !byName) byName = q;
        }
      }
      return both || byNum || byName || null;
    } catch (e) { return null; }
  }

  /* On quote-review we can do better than the bare plan: capture the drawing, render the PDF
     from it, and send the plan the customer is actually looking at complete. Idempotent on the
     reference, so this enriches the row the calculator page already created. */
  var enriched = {};

  function enrichViewedPlan() {
    try {
      var nameEl = document.getElementById('qr-quote-name');
      var name = nameEl ? (nameEl.textContent || '').trim() : '';
      if (!name) return;
      refreshDrawing(function (drawing) {
        try {
          if (!drawing || !drawing.png) return;
          if (drawing.name && drawing.name !== name) return;   // the page moved on
          var q = viewedQuote();
          if (!q || !q.planRef || enriched[q.planRef]) return;
          enriched[q.planRef] = true;
          buildPlanPdf(q, drawing, function (pdf) {
            var extra = {};
            extra[q.planRef] = { drawingPngBase64: drawing.png, pdfBase64: pdf || null };
            pushSavedPlans(extra);
          });
        } catch (e) {}
      });
    } catch (e) {}
  }

  /* ---------- the reference, on screen ---------- */
  // The customer has to be able to read it back to us, so it goes under the quote name.
  function showReference() {
    try {
      var nameEl = document.getElementById('qr-quote-name');
      if (!nameEl) return;
      var q = viewedQuote();
      if (!q || !q.planRef) return;
      var tag = document.getElementById('cf-plan-ref');
      if (!tag) {
        tag = document.createElement('div');
        tag.id = 'cf-plan-ref';
        tag.style.cssText = 'font-size:12.5px;letter-spacing:.04em;opacity:.85;margin-top:4px;' +
          'font-family:ui-monospace,SFMono-Regular,Menlo,monospace;';
        nameEl.parentNode.insertBefore(tag, nameEl.nextSibling);
      }
      var text = 'Reference ' + q.planRef;
      if (tag.textContent !== text) tag.textContent = text;
    } catch (e) {}
  }

  function customerFromEnquiry(c) {
    if (!c) return null;
    var out = {
      name: c.name || '', email: c.email || '', phone: c.phone || '',
      address: c.address || '', suburb: c.suburb || '', postcode: c.postcode || ''
    };
    if (loggedIn()) out.shopifyCustomerId = String(cust().id);
    return out;
  }

  /* The enquiry payload the D1 worker receives is
     { quote: {...}, customer: {...}, quoteReference, pdfBase64, pdfFileName }
     - mirror it into the CRM's shape. quote-review.js already builds a full PDF for that
     enquiry (drawing plus parts list) and it has only ever gone to the worker, which has no
     UI. Forward it. */
  function mirrorEnquiry(raw) {
    try {
      var b = typeof raw === 'string' ? JSON.parse(raw) : raw;
      if (!b || !b.customer) return;
      var q = b.quote || {};

      /* The customer's own reference wins over the one the enquiry minted, so what they see
         on screen is what Pete searches on. */
      var ref = refForEnquiry(q) || b.quoteReference || refFor(q);
      var plan = {
        planName: q.quoteName || null,
        quoteReference: ref,
        calculator: q.calcType || null,
        pricingType: q.pricingType || null,
        grandTotal: q.grandTotal != null ? q.grandTotal : null,
        currency: q.currency || 'AUD',
        sections: q.sections || null,
        lines: q.breakdown || []
      };

      if (b.pdfBase64) plan.pdfBase64 = b.pdfBase64;

      /* "Your Quote" is quote-review's placeholder heading for a plan with no name of its
         own, so it identifies nothing and must not be compared against. */
      /* 15 Oct 2026: the saved drawing is the quote-review screen's, so it only belongs to an enquiry sent
         FROM quote-review. Sent from a calculator page (the "Email me this quote" box beside the price), it
         was whatever plan this tab last showed on quote-review - possibly a different fence. The CRM now
         draws every plan itself from its saved layout (click-quote-intake v10), so nothing is lost. */
      var onReview = location.pathname.indexOf('/pages/quote-review') === 0;
      var drawn = onReview ? readDrawing() : null;
      var drawnName = drawn && drawn.name && drawn.name !== 'Your Quote' ? drawn.name : '';
      var quoteName = q.quoteName ? String(q.quoteName).trim() : '';
      if (drawn && drawn.png && (!drawnName || !quoteName || drawnName === quoteName)) {
        plan.drawingPngBase64 = drawn.png;
      }

      postPlans(customerFromEnquiry(b.customer), [plan], 'Click Fencing calculator enquiry');
    } catch (e) {}
  }

  function bodyToText(body, cb) {
    try {
      if (!body) return cb(null);
      if (typeof body === 'string') return cb(body);
      if (typeof Blob !== 'undefined' && body instanceof Blob) {
        if (body.text) { body.text().then(cb).catch(function () { cb(null); }); return; }
        return cb(null);
      }
      if (typeof body === 'object') return cb(JSON.stringify(body));
      cb(null);
    } catch (e) { cb(null); }
  }

  function installMirror() {
    try {
      if (window.__cfPlansMirror) return;
      window.__cfPlansMirror = true;

      var origFetch = window.fetch;
      if (typeof origFetch === 'function') {
        window.fetch = function (input, init) {
          try {
            var url = typeof input === 'string' ? input : (input && input.url) || '';
            if (ENQUIRY_RE.test(url) && init && init.body) {
              bodyToText(init.body, function (t) { if (t) mirrorEnquiry(t); });
            }
          } catch (e) {}
          return origFetch.apply(this, arguments);
        };
      }

      if (navigator.sendBeacon) {
        var origBeacon = navigator.sendBeacon.bind(navigator);
        navigator.sendBeacon = function (url, data) {
          try {
            if (ENQUIRY_RE.test(String(url))) {
              bodyToText(data, function (t) { if (t) mirrorEnquiry(t); });
            }
          } catch (e) {}
          return origBeacon(url, data);
        };
      }
    } catch (e) {}
  }

  /* ---------- 3. plans follow the account ---------- */

  function pushToAccount() {
    if (!loggedIn()) return;
    try {
      var quotes = [];
      for (var i = 0; i < ALL_KEYS.length; i++) {
        var arr = readQuotes(ALL_KEYS[i]);
        for (var j = 0; j < arr.length; j++) {
          var q = arr[j];
          quotes.push({
            quoteKey: refFor(q),
            calcType: q.calcType || null,
            quoteName: q.quoteName || null,
            pricingType: q.pricingType || null,
            grandTotal: q.grandTotal != null ? q.grandTotal : null,
            currency: q.currency || 'AUD',
            device: 'web',
            quote: q
          });
        }
      }
      if (!quotes.length) return;
      fetch(ACCOUNT_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ quotes: quotes })
      }).catch(function () {});
    } catch (e) {}
  }

  /* Plans saved on another device. Merged in, never overwriting a local plan of the same
     key - the copy in front of the customer is the one they just touched. */
  function pullFromAccount() {
    if (!loggedIn()) return;
    try {
      fetch(ACCOUNT_API, { method: 'GET', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data || !data.ok || !data.quotes || !data.quotes.length) return;
          var touched = {};
          data.quotes.forEach(function (row) {
            try {
              var q = row.quote;
              if (!q || !q.calcType) return;
              var key = keyForCalcType(q.calcType);
              if (!key) return;
              var arr = readQuotes(key);
              var have = arr.some(function (x) { return refFor(x) === row.quoteKey; });
              if (have) return;
              if (row.quoteName) q.quoteName = row.quoteName;
              arr.push(q);
              writeQuotes(key, arr);
              touched[key] = true;
            } catch (e) {}
          });
          if (Object.keys(touched).length) {
            try { if (typeof window.renderQuotesPanel === 'function') window.renderQuotesPanel(); } catch (e) {}
          }
        })
        .catch(function () {});
    } catch (e) {}
  }

  /* ---------- 1. name a plan ---------- */

  function activePill() {
    return document.querySelector('.qr-quote-pill.is-active') ||
           document.querySelector('.qr-quote-pill');
  }

  function keyForCalcType(calcType) {
    var t = String(calcType || '').toLowerCase();
    if (t.indexOf('flat') >= 0) return 'flattop_quotes';
    if (t.indexOf('blade') >= 0) return 'blade_quotes';
    if (t.indexOf('perf') >= 0 || t.indexOf('mesh') >= 0) return 'perfmesh_quotes';
    return 'ullc_quotes';
  }

  function renameQuote(calcType, quoteNum) {
    try {
      var key = keyForCalcType(calcType);
      var arr = readQuotes(key);
      var idx = -1;
      for (var i = 0; i < arr.length; i++) {
        if (String(arr[i].quoteNum) === String(quoteNum)) { idx = i; break; }
      }
      if (idx < 0) return;
      var current = arr[idx].quoteName || '';
      var next = window.prompt('Name this plan\n\nGive it something you will recognise later, like "Back pool fence" or "Side gate run".', current);
      if (next === null) return;
      next = String(next).trim().slice(0, 120);
      if (!next) return;
      arr[idx].quoteName = next;
      if (!writeQuotes(key, arr)) return;

      // Keep the account copy and the CRM in step with the new name.
      pushToAccount();
      crmSent = {};             // the name changed, so this is genuinely new information
      pushSavedPlans();
      location.reload();
    } catch (e) {}
  }

  function addRenameButton() {
    try {
      var del = document.getElementById('qr-clear-btn');
      if (!del || document.getElementById('cf-name-plan-btn')) return;
      var pill = activePill();
      if (!pill) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.id = 'cf-name-plan-btn';
      b.className = 'qr-btn qr-btn--ghost';
      b.textContent = 'Name this plan';
      b.addEventListener('click', function () {
        var p = activePill(); if (!p) return;
        renameQuote(p.dataset.calcType, p.dataset.quoteNum);
      });
      del.parentNode.insertBefore(b, del);
    } catch (e) {}
  }

  /* ---------- install ---------- */

  /* The review page ships the supply-and-install wording in the template, because static
     Liquid cannot know which plan the customer is about to look at. Swap it for a DIY plan,
     matching the PDF exactly. Pete, 2026-09-03: "this part at the bottom of quotes is for
     supply and install however these quotes are for diy. the price will be 100% accurate
     for the parts listed." */
  var DISCLAIMER_DIY = "Supply only (DIY). The price above is exact for the parts listed - it is not an estimate. It assumes the measurements you entered are correct, so please check them before ordering. Prices include GST. Installation is not included.";
  var DISCLAIMER_INSTALL = "This is an estimate based on the configuration you entered. Final pricing may vary subject to site inspection, access conditions, and material availability. GST inclusive where applicable.";

  function showDisclaimer() {
    try {
      var el = document.getElementById('qr-disclaimer') ||
               document.querySelector('.qr-disclaimer');
      if (!el) return;
      var q = viewedQuote();
      if (!q) return;
      var want = (q.pricingType === 'install') ? DISCLAIMER_INSTALL : DISCLAIMER_DIY;
      if (el.textContent.trim() !== want) el.textContent = want;
    } catch (e) { /* never break the page over a paragraph */ }
  }

  function initReview() {
    ensureRefs();
    /* Land the plan in the CRM as soon as the customer reaches the review page, not
       only if the drawing and PDF capture succeeds. enrichViewedPlan attaches those to
       the same plan reference afterwards. */
    pushSavedPlans();
    setInterval(pushSavedPlans, 20000);
    addRenameButton();
    showReference();
    showDisclaimer();
    refreshDrawing();
    if (window.MutationObserver) {
      new MutationObserver(function () {
        addRenameButton(); showReference(); showDisclaimer(); refreshDrawing();
      }).observe(document.body, { childList: true, subtree: true });
    }
    setInterval(addRenameButton, 900);
    setInterval(function () { showReference(); showDisclaimer(); refreshDrawing(); }, 2000);

    /* Give the page time to hydrate and the diagram time to draw, then send the plan
       complete - reference, parts, drawing and PDF. */
    setTimeout(enrichViewedPlan, 3000);
    setInterval(enrichViewedPlan, 15000);

    pullFromAccount();
    pushToAccount();
  }

  function install() {
    installMirror();   // must be up before any enquiry can be sent, on every page

    if (location.pathname.indexOf('/pages/quote-review') === 0) { initReview(); return true; }
    if (!QUOTES_KEY[location.pathname]) return true;

    /* On a calculator page: give every saved plan a reference and get it into the CRM as
       soon as the page has settled, whether or not it is ever sent anywhere. Repeated on a
       timer because a plan is saved while the customer is still on the page. */
    setTimeout(function () { pushToAccount(); pushSavedPlans(); }, 2500);
    setInterval(pushSavedPlans, 20000);
    try { console.log('[cf-plans] installed'); } catch (e) {}
    return true;
  }

  function tryInstall() {
    var done = false;
    try { done = install(); } catch (e) {}
    if (done) return;
    if (++TRIES < MAX_TRIES) setTimeout(tryInstall, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInstall);
  } else {
    tryInstall();
  }
})();
